import React, {
  ReactElement, ReactNode, useCallback, useEffect, useMemo, useState,
} from 'react';
import { useLocation } from 'react-router';
import Context, { ClientStatusContextType } from './ClientStatusContext';
import { ClientStatus } from '../../../model/ClientStatus';

interface Props {
  children: ReactNode;
}

const ClientStatusContextProvider = ({ children }: Props): ReactElement => {
  const [statusState, setStatusState] = useState<ClientStatus | null>();
  const [displayed, setDisplayed] = useState<boolean | null>(false);
  const currentLocation = useLocation();

  useEffect(() => {
    setDisplayed(true);
  }, [currentLocation]);

  const handleStatus = useCallback((status: ClientStatus) => {
    setStatusState(status);
    setDisplayed(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (displayed) {
      setStatusState(null);
    }
  }, [displayed]);

  const clearStatus = (): void => {
    setStatusState(null);
  };

  const value: ClientStatusContextType = useMemo(() => ({
    status: statusState,
    handleStatus,
    clearStatus,
  }), [handleStatus, statusState]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export default ClientStatusContextProvider;
